import { Component, Inject, OnInit } from '@angular/core';
import { ChainActivePartModel, ChainActivePartVM, DealershipsCustomers, UserDealerGroup, UserDealerGroupDealerships } from '../../setup-models/setup-models.model';
import { FormControl, Validators } from '@angular/forms';
import { SetupModelsService } from '../../setup-models/setup-models.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BillingDetailComponent } from '../billing-detail/billing-detail.component';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'app-confirm-pop-up',
  templateUrl: './confirm-pop-up.component.html',
  styleUrls: ['./confirm-pop-up.component.scss']
})
export class ConfirmPopUpComponent implements OnInit {
  validEmailString: boolean = false;
  emailAddress: string = "";
  emailControl: FormControl;
  userDealerGroupDealerships: UserDealerGroupDealerships[];
  dealerGroupId: number;
  dealershipId: number;
  selectedCustomer: number;
  dealershipsCustomers: DealershipsCustomers[];
  chainId:number;
  FirstName:string;
  LastName:string;
  ContactNo:number;
  checked:number;
  BillingAddress: string;
  DeliveryAddress: string;
  userDealerGroup: UserDealerGroup[];
  IsBillingActive : boolean=false;
 chainActivePartModel:ChainActivePartModel[]=[];
  constructor( @Inject(MAT_DIALOG_DATA) private _data: any,public dialogRef: MatDialogRef<BillingDetailComponent>
  , public _modelService: SetupModelsService,private _notify: NotificationsService) { }


  ngOnInit(): void {
    this.chainId = this._data.ChainID;
    this.chainActivePartModel= this._data.QuoteData;
    this.GetUserDealerGroup();
    this.emailControl = new FormControl(this.emailAddress, [
      Validators.required,
      Validators.email,
    ]);

    this.dealerGroupId=this._data.QuoteData.DealerGroupId;
       
      this.FirstName=this._data.QuoteData.FirstName
      this.LastName=this._data.QuoteData.LastName;
      this.emailAddress=this._data.QuoteData.EmailId;
      this.ContactNo=this._data.QuoteData.ContactNumber;
      this.BillingAddress=this._data.QuoteData.BillingAddress;
      this.DeliveryAddress=this._data.QuoteData.DeliveryAddress;
      if(this.BillingAddress== this.DeliveryAddress){
        this.checked=1;
      }else{
        this.checked=0;
      }
      
    
  }

  changeCheckbox(event: any) {
    if (event.checked) {
      this.BillingAddress = this.DeliveryAddress
    }else{
      this.BillingAddress="";
    }
  }     
  partConfigQuoteId:number;
  SavePartConfiqQuote() {
    debugger;
    let Isconfirm:boolean;
    Isconfirm=true;
    this._modelService.SavePartConfiqQuote(this.dealerGroupId,this.dealershipId,this.selectedCustomer,
      this.FirstName, this.LastName, this.emailAddress, this.chainId,this.ContactNo,this.BillingAddress,this.DeliveryAddress,Isconfirm
    ).subscribe(result => {
     
        debugger;
        this.partConfigQuoteId= result;
        this.SaveQuoteDetails();
        this._notify.success("Billing Details Saved Successfully!");
        this.dialogRef.close();
     
    })
  }

  onNoClick() {
    this.dialogRef.close(false);
  }
  checkEmailAddress() {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.validEmailString = re.test(String(this.emailAddress).toLowerCase());
  }

  GetUserDealerGroup() {
    this._modelService.GetUserDealerGroup().subscribe(result => {
      this.userDealerGroup = result;
      if(this._data.QuoteData!=null){
        this.dealerGroupId=this._data.QuoteData.DealerGroupId;
        this.GetUserDealerGroupDealerships();
      }
    })
  }

  GetUserDealerGroupDealerships() {
    this._modelService.GetUserDealerGroupDealerships(this.dealerGroupId).subscribe(result => {
      this.userDealerGroupDealerships = result;
     
    
      if(this._data.QuoteData!=null){
       
        this.dealershipId=this._data.QuoteData.DealershipId;
        this.GetDealerGroupDealershipsCustomers();
      }
    })
  }

  GetDealerGroupDealershipsCustomers() {
    this._modelService.GetDealerGroupDealershipsCustomers(this.dealershipId).subscribe(result => {
      this.dealershipsCustomers = result;
      if(this._data.QuoteData!=null){
        this.selectedCustomer=this._data.QuoteData.CustomerId;
      }
    })
  }

  OndealerGroupSelect() {
    this.GetUserDealerGroupDealerships();
  }


  OndealershipSelect() {
    this.GetDealerGroupDealershipsCustomers();
  }
  ActiveBillingSection(){
    this.dialogRef.close(true);
  }
  ChainActivePartVM :ChainActivePartVM;
  SaveQuoteDetails() {
    debugger;
    this.ChainActivePartVM = new ChainActivePartVM();
    this.ChainActivePartVM.partQuoteId=this.partConfigQuoteId;
    this.ChainActivePartVM.chainId = this.chainId;
    this.ChainActivePartVM.chainPartData = this.chainActivePartModel;
    this._modelService.SaveQuoteDetails(this.ChainActivePartVM).subscribe(result => {
      if (result != null) {
        this._notify.success('Quote details saved successfully')
      }

    })
  }
}
